// ╭────────────────────────────────────────────────────────────────────────────────────╮
// ┊  This file was automatically generated
// ┊  Please do not modify manually
// ┊  ©gl it 2026 - http://www.gl-it.ch
// ╰────────────────────────────────────────────────────────────────────────────────────╯

/* eslint-disable quote-props */

import DataRecord, { unwrapDataRecord } from '@glittr/frontend-core/src/core/v2/data/data-record';
import ServiceModelBase from '@glittr/frontend-core/src/core/v2/data/service-model-base';
import DeepPartial from '@glittr/frontend-core/src/core/v2/utility-types/deep-partial';
import GetAnalyticsForOrganisationRequestModel from '../../model/get-analytics-for-organisation-request-model';
import GetAnalyticsForOrganisationRequestDTO from '../dto/get-analytics-for-organisation-request-dto';
import dtoSchema from '../schemas/get-analytics-for-organisation-request-schema';

export default abstract class GetAnalyticsForOrganisationRequestModelBase extends ServiceModelBase {
  constructor(data?: DeepPartial<GetAnalyticsForOrganisationRequestDTO>) {
    super();
    this.paging = {};
    if (data) {
      this.paging = {
        currentPage: data['paging.CurrentPage'],
        pageSize: data['paging.PageSize'],
        includeCount: data['paging.IncludeCount'],
        noPaging: data['paging.NoPaging'],
      };
      this.organisationId = data.organisationId;
      this.selectedOrganisationId = data.selectedOrganisationId;
      this.selectedCompanyId = data.selectedCompanyId;
      this.eventIdentifier = data.eventIdentifier;
      this.id = data.id;
      this.key = data.key;
      this.searchCriteria = data.searchCriteria;
    }
  }

  paging: {
    /**
    * @type {int32}
    */
    currentPage?: number;
    /**
    * @type {int32}
    */
    pageSize?: number;
    /**
    */
    includeCount?: boolean;
    /**
    */
    noPaging?: boolean;
  };

  /**
  * @type {int64}
  */
  organisationId?: number;
  /**
  * @type {int64}
  */
  selectedOrganisationId?: number;
  /**
  * @type {int64}
  */
  selectedCompanyId?: number;
  /**
  * @type {uuid}
  */
  eventIdentifier?: string;
  /**
  * @type {int64}
  */
  id?: number;
  /**
  */
  key?: string;
  /**
  */
  searchCriteria?: string;

  static toModel(dto: DeepPartial<GetAnalyticsForOrganisationRequestDTO>): GetAnalyticsForOrganisationRequestModel;
  static toModel(dto: DeepPartial<GetAnalyticsForOrganisationRequestDTO> | undefined | null): GetAnalyticsForOrganisationRequestModel | undefined;
  static toModel(dto: DeepPartial<GetAnalyticsForOrganisationRequestDTO> | undefined | null): GetAnalyticsForOrganisationRequestModel | undefined {
    return dto ? new GetAnalyticsForOrganisationRequestModel(dto) : undefined;
  }
  static toDTO(model: DataRecord<GetAnalyticsForOrganisationRequestModel> | GetAnalyticsForOrganisationRequestModel): GetAnalyticsForOrganisationRequestDTO {
    const unwrapped = unwrapDataRecord(model);
    const dto = {
      'paging.CurrentPage': unwrapped.paging?.currentPage,
      'paging.PageSize': unwrapped.paging?.pageSize,
      'paging.IncludeCount': unwrapped.paging?.includeCount,
      'paging.NoPaging': unwrapped.paging?.noPaging,
      organisationId: unwrapped.organisationId,
      selectedOrganisationId: unwrapped.selectedOrganisationId,
      selectedCompanyId: unwrapped.selectedCompanyId,
      eventIdentifier: unwrapped.eventIdentifier,
      id: unwrapped.id,
      key: unwrapped.key,
      searchCriteria: unwrapped.searchCriteria,
    } as GetAnalyticsForOrganisationRequestDTO;
    const errors = ServiceModelBase.validator.validate(dtoSchema, dto);
    if (errors.length > 0) {
      throw new Error(`Invalid data for GetAnalyticsForOrganisationRequestModel, can not map to GetAnalyticsForOrganisationRequestDTO: ${errors.map((e) => `${e?.propName}: ${e?.message}`).join(', ')}`);
    }
    return dto;
  }

  validate(): boolean {
    const dtoErrors = this.getValidationErrors(dtoSchema);
    const modelErrors = this.getValidationErrors(this.schema ?? {});
    this.errors = [...dtoErrors, ...modelErrors];
    return this.errors.length === 0;
  }
}
